import { isDate } from 'date-fns';

export const isValidDate = (date: Date) =>
  isDate(date) && !Number.isNaN(date.getTime());
